import { Injectable } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root",
})
export class TimeService {
  constructor() {}

  substractString(time: string) {
    let result = time.substring(
      time.lastIndexOf("T") + 1,
      time.lastIndexOf(":")
    );
    return result;
  }

  monthsLocalizedArray(month, locale) {
    return new Date(2010, month).toLocaleString(locale, { month: "long" });
  }

  /*Fix bloody day and month for ISO 8601*/
  leadingZero(n) {
    return (n < 10 ? "0" : "") + n;
  }

  dateIsoTransform(date: NgbDate) {
    let month;
    let day;
    let endDate;

    if (date.month < 10) {
      month = this.leadingZero(date.month);
    } else {
      month = date.month;
    }

    if (date.day < 10) {
      day = this.leadingZero(date.day);
    } else {
      day = date.day;
    }

    endDate = date.year + "-" + month + "-" + day + "T00:00:00";
    return endDate;
  }
}
